import { render, staticRenderFns } from "./PremiumFeaturesChoice.vue?vue&type=template&id=38d0034e&scoped=true&"
import script from "./PremiumFeaturesChoice.vue?vue&type=script&lang=js&"
export * from "./PremiumFeaturesChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d0034e",
  null
  
)

export default component.exports